import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { IndividualFiltersService } from '~/api/services/individualFilters'
import CustomIcon from '~/components/CustomIcon'
import Dialog from '~/components/Dialog'
import { El } from '~/components/Layout/style'
import notify from '~/components/Notify'
import TableComponent from '~/components/TableComponent'
import { LIGHT_USER_ROLE_SLUG } from '~/Constants'
import IndividualFiltersQuery from '~/QueryHooks/IndividualFiltersQuery'
import { RouteTypes } from '~/routes/constants'
import { handleErrors } from '~/utils/helpers'
import { AssignedContent, TableActionWrapper } from '../style'
import NotAssignedModal from '../NotAssignedModal'
import { FilterEnums } from '../types'
import AssignedModal from '../AssignedModal'

const AmountFilter:React.FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  const [dataFiltered, setDataFiltered] = useState({
    page: 0,
    rows: 10
  })
  const [deleteFilterData, setDeleteFilterData] = useState(null)
  const [isDeleteLoading, setIsDeleteLoading] = useState(false)
  const [isNotAssignedModalOpen, setIsNotAssignedModalOpen] = useState(false)
  const [assignedFilterId, setAssignedFilterId] = useState(null)

  const tableColumnHeaders = [
    {
      name: t('Name'),
      key: 'name'
    },
    {
      name: t('Amount from'),
      key: 'amountFrom',
      type: 'number'
    },
    {
      name: t('Amount to'),
      key: 'amountTo',
      type: 'number'
    },
    {
      name: t('Year'),
      key: 'year'
    },
    {
      name: t('Actions')
    }
  ]
  const tableActions = [
    {
      popupMessage: t('Edit'),
      type: 'link',
      name: 'pencil',
      size: 'large',
      link: RouteTypes.DAIRY_FACTORY_PROFILE_INDIVIDUAL_FILTERS_AMOUNT_EDIT,
      disableForRoleSlug: LIGHT_USER_ROLE_SLUG
    },
    {
      popupMessage: t('Assigned farmers'),
      type: 'icon',
      name: 'icon-teamwork',
      size: 'large',
      actionType: 'assignedFarmers'
    },
    {
      popupMessage: t('Delete'),
      type: 'icon',
      name: 'trash',
      size: 'large',
      actionType: 'delete',
      disableForRoleSlug: LIGHT_USER_ROLE_SLUG
    }
  ]

  const {
    data: amountInfo
  } = IndividualFiltersQuery.getAmountInfo()

  const {
    data: amountFilters,
    isLoading: isLoadingFilters,
    isFetching: isFetchingData,
    refetch: fetchFilters
  } = IndividualFiltersQuery.getAmountFilters()

  function renderActions() {
    return <div style={{ display: 'flex', alignItems: 'center', gap: 5 }}>
      <El.PageHeaderActionButton
        onClick={() => setIsNotAssignedModalOpen(true)}
      >{t('Not assigned')}
      </El.PageHeaderActionButton>
      <El.PageHeaderActionButton
        onClick={() => navigate(RouteTypes.DAIRY_FACTORY_PROFILE_INDIVIDUAL_FILTERS_AMOUNT_CREATE)}
      >{t('Create')}
      </El.PageHeaderActionButton>
    </div>
  }
  
  function handleActionClick(row, type) {
    switch(type) {
      case 'delete':
        return setDeleteFilterData(row)
      case 'assignedFarmers':
        return setAssignedFilterId(row?.id)
      default:
        return
    }
  }

  function renderTable() {
    return <TableComponent
      tableColumnHeaders={tableColumnHeaders}
      actions={tableActions}
      animated
      isFetchingData={isFetchingData || isLoadingFilters}
      handleClickAction={handleActionClick}
      dataFiltered={dataFiltered}
      handleChangeDataFiltered={(data) => setDataFiltered(data)}
      total={filtered}
      rows={rows}
    />
  }

  async function handleDeleteFilter() {
    setIsDeleteLoading(true)
    try {
      await IndividualFiltersService.filtersAmountDelete(deleteFilterData?.id)
      setDeleteFilterData(null)
      notify(t('Successfully deleted amount filter'), 'success')
      fetchFilters()
    }catch(error) {
      handleErrors(error)
    }finally{
      setIsDeleteLoading(false)
    }
  }

  function renderDeleteFilter() {
    return <Dialog
      isDialogOpen={Boolean(deleteFilterData)}
      isLoading={isDeleteLoading}
      type={'abort'}
      handleClose={() => setDeleteFilterData(null)}
      textHeader={t('Delete filter: {{name}}', { name: deleteFilterData?.name })}
      textClose={t('Cancel')}
      textContent={t('Do you really want to delete filter: {{name}}?', { name: deleteFilterData?.name })}
      textSubmit={t('Delete')}
      handleSubmit={() => handleDeleteFilter()}
    />
  }

  function renderNotAssignedFarmers() {
    return <NotAssignedModal
      handleClose={() => setIsNotAssignedModalOpen(false)}
      isOpen={isNotAssignedModalOpen}
      type={FilterEnums.Amount}
    />
  }

  function renderAssignedFarmers() {
    return <AssignedModal
      handleClose={() => setAssignedFilterId(null)}
      id={assignedFilterId}
      type={FilterEnums.Amount}
    />
  }

  const { filtered, rows } = amountFilters ? amountFilters : { filtered: 0, rows: [] };

  return <div>
    {renderDeleteFilter()}
    {renderNotAssignedFarmers()}
    {renderAssignedFarmers()}
    <TableActionWrapper>
      <AssignedContent>
        <CustomIcon className='icon-farmer-icon font-size-4' size='large' />
        <div style={{ display: 'flex', flexDirection: 'row', gap: 5 }}>
          <div>{t('Assigned: {{assigned}}', { assigned: amountInfo?.assigned })}</div>
          <div>{t('Not assigned: {{notAssigned}}', { notAssigned: amountInfo?.notAssigned })}</div>
        </div>
      </AssignedContent>
      {renderActions()}
    </TableActionWrapper>
    {renderTable()}
  </div>
}
export default AmountFilter